const cacheKey = 'mrCache';

export enum storageKeys {
  MR_SHOPIFY_FUNCTIONS_CACHE = 'mrSF',
}

export const cacheModule = {
  get: key => {
    const cacheString = sessionStorage.getItem(cacheKey);
    const cache = JSON.parse(cacheString) || {};
    return cache[key];
  },

  set: (key, data) => {
    const cacheString = sessionStorage.getItem(cacheKey);
    const cache = JSON.parse(cacheString) || {};
    cache[key] = data;
    sessionStorage.setItem(cacheKey, JSON.stringify(cache));
  },

  clear: () => {
    sessionStorage.removeItem(cacheKey);
  },

  remove: key => {
    const cacheString = sessionStorage.getItem(cacheKey);
    const cache = JSON.parse(cacheString) || {};
    delete cache[key];
    sessionStorage.setItem(cacheKey, JSON.stringify(cache));
  },
};
